import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * Estado de UI para autorizaciones.
 *
 * `isModoCrearEditar` permite distinguir vistas de listado/detalle frente a
 * flujos de captura o modificacion de autorizaciones.
 */
export const autorizacionesSlice = createSlice({
  name: 'autorizaciones',
  initialState: { isModoCrearEditar: false },
  reducers: {
    cambiarModoCrearEditar: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isModoCrearEditar: action.payload,
    }),
  },
})

export const { cambiarModoCrearEditar } = autorizacionesSlice.actions

export default autorizacionesSlice.reducer
